module.exports = "../study/imgs/maps/Tokyo/S8/Climate/Precipitation/Tokyo_Precipitation_MIROC5_RCP45_Now.png";